// 根据 登录获取用户信息
// import { apiGet, apiPost, apiPatch } from './index'
import { apiGet } from './index'
const loginAuthUrl = `${process.env.baseURL}/auth/Auth/wxpubliclogin`
const login = (params) => apiGet('/auth/Auth/gettoken', params)
const getCurrentUser = (params) => apiGet('/api/Center/userinfo', params)
const jssdkshare = (params) => apiGet('/api/Other/jssdkshare', params)
const getAuthCode = (params) => apiGet('/api/Center/getAuthCode', params)
const getAdaPayOrderToPage = (params) => apiGet('/api/Other/getAdaPayOrderToPage', params) // 微信小票根据订单号code返回内容

export {
  login,
  loginAuthUrl,
  getCurrentUser,
  jssdkshare,
  getAuthCode,
  getAdaPayOrderToPage
}



// WEBPACK FOOTER //
// ./src/api/api.js